import { saveMP3 } from "./indexedDB";
import axiosInstance from "../utils/axios";
import { buildAudioKey, DEMO_AUDIO_KEY } from "../constants/storageKeys";

// export async function downloadAudioToIndexDB(setLoadingListeningAudio, isDemoExam, uprId) {
//     try {
//         if (setLoadingListeningAudio) setLoadingListeningAudio(true);

//         const endpoint = isDemoExam ? "/listening/getDemoExamAudio" : `/listening/getExamAudio/${uprId}`;
//         console.log(1);

//         const response = await axiosInstance.get(
//             endpoint,
//             { responseType: 'blob' }
//         );

//         console.log("2")

//         if (response.status != 200) {
//             throw new Error("Failed to fetch audio");
//         }
//         const blob = response.data;

//         // console.log(blob);

//         await saveMP3((!isDemoExam ? `exam-audio-${uprId}` : "demo-exam-audio"), blob);

//         // console.log("MP3 file stored in IndexedDB!");

//     } catch (error) {
//         console.error("Error fetching MP3 file:", error);
//     } finally {
//         if (setLoadingListeningAudio) setLoadingListeningAudio(false);
//     }
// }




export async function downloadAudioToIndexDB(setLoadingListeningAudio, isDemoExam, uprId) {
    try {
        if (setLoadingListeningAudio) setLoadingListeningAudio(true);

        const endpoint = isDemoExam
            ? "/listening/getDemoExamAudio"
            : `/listening/getExamAudio/${uprId}`;


        const { data } = await axiosInstance.get(endpoint);

        const audioUrl = data?.audioUrl;
        if (!audioUrl) throw new Error("Audio URL missing from backend response");

        const audioResponse = await axiosInstance.get(audioUrl, {
            responseType: "blob",
            withCredentials: false
        });


        if (audioResponse.status !== 200) {
            throw new Error("Failed to fetch audio blob");
        }

        const blob = audioResponse.data;

        const key = !isDemoExam ? buildAudioKey(uprId) : DEMO_AUDIO_KEY;
        await saveMP3(key,
            //  {
            blob,
            // expiresAt: Date.now() + 12 * 60 * 60 * 1000, // ⏰ 12-hour expiration
            // }
        );

        // console.log("Audio saved in IndexedDB under key:", key);
        return key;
    } catch (error) {
        console.error("Error downloading audio:", error);
        return null;
    } finally {
        if (setLoadingListeningAudio) setLoadingListeningAudio(false);
    }
}
